import React from 'react';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

import { Formik, Form as FormikForm } from 'formik';

import { Button } from 'react-bootstrap';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import usePrepareMail from 'components/Common/Slack/Hooks/usePrepareMail';

import {
  TextField,
  TextAreaField,
  SubmitButton,
} from 'ui/FormElement';
import Actions from './Actions';

export default function Form({ enterpriseId, link, onHide }) {
  const FormSchema = Yup.object().shape({
    email: Yup.string().email().required('required'),
    subject: Yup.string().required('required'),
    body: Yup.string().required('required'),
  });

  const mailData = usePrepareMail({ enterpriseId });

  const formData = {
    email: mailData?.email || '',
    subject: mailData?.subject || '',
    body: mailData?.body || '',
  };

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    Actions.sendMail({ ...values, link }, () => {
      onHide();
    });
  };

  if (mailData === null) {
    return <div className="text-center"><LoadingPlaceholder placement="inline" /></div>;
  }

  return (
    <Formik
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <div className="mt20">
            <TextField
              name="email"
              label={(
                <>
                  <span>Email</span>
                  <abbr title="required">*</abbr>
                </>
            )}
            />
            <TextField
              name="subject"
              label={(
                <>
                  <span>Subject</span>
                  <abbr title="required">*</abbr>
                </>
            )}
            />
            <TextAreaField
              name="body"
              rows={10}
              label={(
                <>
                  <span>Body</span>
                  <abbr title="required">*</abbr>
                </>
            )}
            />

          </div>
          <div className="text-center mt20">
            <Button
              bsStyle="primary"
              className="mr5 ml5 width-120  btn-outline"
              onClick={onHide}
            >
              Cancel
            </Button>

            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Send'}
              className={`btn width-120 btn-primary submit-button mr5 ml5 ${
                isSubmitting ? 'not-possible-click' : ''
              }`}
            />
          </div>
        </FormikForm>
      )}
    </Formik>
  );
}

Form.propTypes = {
  link: PropTypes.string.isRequired,
  enterpriseId: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
};
